import React, { useState, useEffect } from "react";
import { RepositoryFactory } from "../Repository/RepositoryFactory";
import { Box, Typography, styled } from "@mui/material";
import DataTableComponent from "./reusableComponents/DataTable";
import BillPreview from "./reusableComponents/BillPreview";
const BillsRepository = RepositoryFactory.get("bills_repository");
import ClipLoader from "react-spinners/ClipLoader";
import billImg from "../images/bill.png";

const customStyles = {
  rows: {
    style: {
      minHeight: "60px",
      background: "white",
      padding: "2px 10px",
      marginTop: "5px",
    },
  },
  header: {
    style: {
      color: "#4EAF50",
    },
  },
  headCells: {
    style: {
      backgroundColor: "#4EAF50",
      color: "white",
      fontSize: "16px",
    },
  },
  cells: {
    style: {
      paddingLeft: "18px",
    },
  },
  table: {
    style: {
      background: "#EBEBEB",
      marginBottom: "20px",
    },
  },
};

function SaleBillReturn() {
  const [modal, setModal] = useState(false);
  const [state, setState] = useState({
    bills: [],
    loading: false,
    selectedBill: "",
  });
  const columns = [
    {
      name: "#",
      width: "150px",
      selector: (row, i) => i + 1,
    },
    {
      name: "Preview",
      width: "200px",
      selector: (row) => (
        <img
          src={billImg}
          style={{ cursor: "pointer" }}
          height="50px"
          onClick={() => rowClicked(row)}
        />
      ),
    },
    {
      name: "Bill Number",
      selector: (row) => row.billNumber,
      sortable: true,
    },
    {
      name: "Date",
      selector: (row) => row.date,
      sortable: true,
    },
  ];
  useEffect(() => {
    getBills();
  }, []);

  const toggle = () => {
    setModal((prevState) => !prevState);
  };
  const getBills = async () => {
    setState((prevState) => ({ ...prevState, loading: true }));
    let { data } = await BillsRepository.billsModel({
      request: {
        method: "getBillsBySaleReturn",
        data: {
          company_code: localStorage.getItem("companyCode"),
        },
      },
    });
    setState((prevState) => ({
      ...prevState,
      bills: data.response.data.items,
      loading: false,
    }));
  };
  const rowClicked = (data) => {
    setState((prevState) => ({ ...prevState, selectedBill: data }));
    toggle();
  };

  return (
    <Box sx={{ marginTop: "65px" }}>
      <Typography align="center" variant="h6" style={{ color: "#4EAF51" }}>
        Return Bills
      </Typography>
      {!state.loading && (
        <DataTableComponent
          columns={columns}
          data={state.bills}
          customStyles={customStyles}
        />
      )}
      <BillPreview
        title="Bill Preview"
        open={modal}
        onClose={toggle}
        onClickCancel={toggle}
        bill={state.selectedBill}
        returnBillPrint={"true"}
        fivePercent="ignore"
      />
      {state.loading == true && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <ClipLoader size={50} color="#4DAF51" loading={state.loading} />
        </Box>
      )}
    </Box>
  );
}
export default SaleBillReturn;
